import { CLEF_OFFSETS } from "./constants";
import { Handler } from "./handler";

export interface MidiStruct {
  loadPlugin: (opts: any) => void;
  noteOn: any;
  noteOff: any;
  chordOn: any;
  chordOff: any;
  keyToNote: any;
}

export type ClefType = keyof typeof CLEF_OFFSETS;

export interface PlayInfo {
  clef: ClefType;
  defaultTime: number;
  delay: number;
  rpm: number;
}

export default class Player {
  private events: any[] = [];
  private handler: Handler;
  public currentTime: number = 0;
  public currentEventIndex: number = 0;
  public ready: boolean = false;
  public playing: boolean = false;
  public callback: any;
  private scheduledId: any = null;

  constructor(handler: Handler) {
    this.handler = handler;

    this.loadInstrument("acoustic_grand_piano");
  }

  private loadInstrument = (instrumentName: string, onReady?: any) => {
    var player = this;
    // Initialize the player
    const MIDI: MidiStruct = window.MIDI as unknown as MidiStruct;
    MIDI.loadPlugin({
      soundfontUrl: "./soundfont/",
      instrument: instrumentName,
      callback: function () {
        player.ready = true;
        if (onReady) onReady();
      },
    });
  };

  public onPlayFinished = (callback?: any) => {
    this.callback = callback;
  };

  public addEvent = (event: any) => {
    this.events.push(event);
  };

  public addEvents = (eventList: any) => {
    this.events = this.events.concat(eventList);
  };

  public play = () => {
    let self = this;
    if (self === undefined) self = this;
    self.playing = true;
    if (self.currentEventIndex >= self.events.length) {
      self.playing = false;
      return self.callback();
    }

    var event = self.events[self.currentEventIndex];

    if (self.currentTime <= event.queuedTime) {
      //Fire the event
      self.fireEvent(event);

      //Increment the current event and add current time
      if (self.currentEventIndex + 1 >= self.events.length) {
        self.playing = false;
        return self.callback();
      }
      var timeUntilNextEvent =
        self.events[self.currentEventIndex + 1].queuedTime -
        self.events[self.currentEventIndex].queuedTime;

      self.currentEventIndex++;
      self.currentTime += timeUntilNextEvent;

      self.scheduledId = setTimeout(self.play, timeUntilNextEvent * 1000, self);
    }
  };

  public stop = () => {
    if (this.scheduledId) {
      clearTimeout(this.scheduledId);
      this.clear();
      this.playing = false;
      while (this.events.length) {
        var event = this.events.pop();
        if (event.subtype == "noteOff" || event.subtype == "chordOff")
          this.fireEvent(event);
      }
    }
  };

  private fireEvent = (event: any) => {
    const MIDI: MidiStruct = window.MIDI as unknown as MidiStruct;

    switch (event.subtype) {
      case "noteOn":
        MIDI.noteOn(event.channel, event.noteNumber, event.velocity, 0);
        event.note.setHighlight(true);
        this.handler.redraw();
        break;
      case "noteOff":
        MIDI.noteOff(event.channel, event.noteNumber, 0);
        event.note.setHighlight(false);
        this.handler.redraw();
        break;
      case "chordOn":
        MIDI.chordOn(event.channel, event.noteNumber, event.velocity, 0);
        event.note.setHighlight(true);
        this.handler.redraw();
        break;
      case "chordOff":
        MIDI.chordOff(event.channel, event.noteNumber, 0);
        event.note.setHighlight(false);
        this.handler.redraw();
        break;
    }
  };

  private clear = () => {
    this.scheduledId = null;
    this.currentTime = 0;
    this.currentEventIndex = 0;
  };
}
